import { Component } from '@angular/core';
import { AnonymousContentPage } from 'shared.components/anonymous-content-page/anonymous-content-page';

@Component({
  selector: '[nc-login]',
  templateUrl: './login.component.html',
  standalone: false,
})
export class LoginComponent extends AnonymousContentPage {

  constructor(
  ) {
    super();
  }
}
